export type IApi = any;

export class Api implements IApi {}
